import React from 'react';
import { FieldState } from 'formstate';
import { observer } from 'mobx-react';
import { MatField } from 'src/core/components/mat-field';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as styles from './application.less';
import * as Utils from '../../forms/application-information-forms-utils';
import { ResidenceForm } from '../../forms/application-information-forms';

interface IResidenceInformationProps {
    residence: ResidenceForm;
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}

export const ResidenceInformation: React.FC<IResidenceInformationProps> = observer(
    ({ residence, validate }) => {
        return (
            <React.Fragment>
                <div className={styles.sectionTitle}>Do you own or rent? *</div>
                <div className={styles.radioRow}>
                    <RadioGroup
                        row
                        value={residence.$.HousingType.value}
                        onChange={(e, val) => residence.$.HousingType.onChange(val)}
                    >
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="Own"
                            control={<Radio className={styles.radio} />}
                            label="Own"
                        />
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="Rent"
                            control={<Radio className={styles.radio} />}
                            label="Rent"
                        />
                    </RadioGroup>
                </div>
                <div className={styles.sectionTitle}>Property Type *</div>
                {residence.$.HousingType.value && (
                    <div className={styles.nextRadioRow}>
                        <MatField
                            required
                            fullWidth
                            errorColor
                            fieldState={residence.$.MonthlyPayment}
                            maxLength={26}
                            formatter={Utils.formatAmount}
                            validator={Utils.amountValidator}
                            label={
                                residence.$.HousingType.value === 'Own'
                                    ? 'Monthly Mortgage Amount ($)'
                                    : 'Rental Amount ($)'
                            }
                            startAdornment="$"
                            onBlur={validate(residence.$.MonthlyPayment)}
                        />
                    </div>
                )}
                <div className={styles.radioRow}>
                    <RadioGroup
                        row
                        value={residence.$.PropertyType.value}
                        onChange={(e, val) => residence.$.PropertyType.onChange(val)}
                    >
                        <FormControlLabel
                            value="Single Family"
                            control={<Radio className={styles.radio} />}
                            label="Single Family"
                        />
                        <FormControlLabel
                            value="Manufactured Home"
                            control={<Radio className={styles.radio} />}
                            label="Manufactured Home"
                        />
                    </RadioGroup>
                </div>
            </React.Fragment>
        );
    }
);
